export default __webpack_public_path__ + "static/media/cloud-download.0f8a9b4e.svg";